export default "__VITE_ASSET__5dIT0Pu6__"